import {
  getStaticProxyList,
  getStaticProxyRenewalList,
  exportStaticProxyList,
  purchaseStaticProxy,
  renewProxy
} from '@/api/proxy'
import * as XLSX from 'xlsx'

const state = {
  proxyList: [],
  renewalList: [],
  total: 0,
  loading: false,
  renewalTotal: 0,
  renewalLoading: false,
  purchaseLoading: false
}

const mutations = {
  SET_PROXY_LIST: (state, { list, total }) => {
    state.proxyList = list || []
    state.total = total || 0
  },
  SET_LOADING: (state, loading) => {
    state.loading = loading
  },
  SET_RENEWAL_LIST: (state, { list, total }) => {
    state.renewalList = list || []
    state.renewalTotal = total || 0
  },
  SET_RENEWAL_LOADING: (state, loading) => {
    state.renewalLoading = loading
  },
  SET_PURCHASE_LOADING: (state, loading) => {
    state.purchaseLoading = loading
  }
}

const actions = {
  // 获取静态代理列表
  async getProxyList({ commit }, params) {
    console.log('开始获取代理列表, 参数:', params)
    commit('SET_LOADING', true)
    try {
      const response = await getStaticProxyList(params)
      console.log('获取代理列表响应:', response)
      
      if (!response) {
        throw new Error('未收到服务器响应')
      }

      // 处理新的API响应格式
      if (response.code === 200) {
        const data = response.data || {}
        const resultItems = Array.isArray(data.list) ? data.list : []
        const resultTotal = parseInt(data.total) || 0
        commit('SET_PROXY_LIST', { list: resultItems, total: resultTotal })
        return response.data
      } else {
        throw new Error(response.message || '获取数据失败')
      }
    } catch (error) {
      console.error('获取代理列表失败:', error)
      commit('SET_PROXY_LIST', { list: [], total: 0 })
      throw error // 向上传递错误以便UI层处理
    } finally {
      commit('SET_LOADING', false)
    }
  },

  // 获取续期记录列表
  async getRenewalList({ commit }, params) {
    commit('SET_RENEWAL_LOADING', true)
    try {
      const response = await getStaticProxyRenewalList(params)
      if (response.code === 200) {
        commit('SET_RENEWAL_LIST', {
          list: response.data.list || [],
          total: response.data.total || 0
        })
      }
    } catch (error) {
      console.error('获取续期记录失败:', error)
      commit('SET_RENEWAL_LIST', { list: [], total: 0 })
    } finally {
      commit('SET_RENEWAL_LOADING', false)
    }
  },

  // 导出代理列表
  async exportProxyList(_, params) {
    try {
      // 获取响应数据
      const response = await exportStaticProxyList(params)
      const base64Data = response.data
      
      // 直接使用XLSX库处理Base64数据，避免编码转换问题
      const workbook = XLSX.read(base64Data, { type: 'base64', codepage: 65001 })
      
      // 生成XLSX文件
      const xlsxBuffer = XLSX.write(workbook, { 
        bookType: 'xlsx', 
        type: 'array',
        codepage: 65001 // 使用UTF-8编码
      })
      
      // 创建Blob对象
      const blob = new Blob([xlsxBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
      
      // 生成文件名
      const fileName = `静态代理IP列表_${new Date().toISOString().slice(0, 10)}.xlsx`
      
      // 创建下载链接
      const url = window.URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', fileName)
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      window.URL.revokeObjectURL(url)
      
      return Promise.resolve()
    } catch (error) {
      console.error('导出列表失败:', error)
      throw error
    }
  },

  // 设置购买加载状态
  setPurchaseLoading({ commit }, loading) {
    commit('SET_PURCHASE_LOADING', loading)
  },

  // 购买代理
  async purchaseStaticProxy({ commit }, data) {
    commit('SET_PURCHASE_LOADING', true)
    try {
      const response = await purchaseStaticProxy(data)
      if (response.code === 200) {
        return response.data
      }
      throw new Error(response.message || '购买失败')
    } finally {
      commit('SET_PURCHASE_LOADING', false)
    }
  },

  // 续期代理
  async renewProxy({ dispatch }, data) {
    try {
      const response = await renewProxy(data)
      if (response.code === 200) {
        // 刷新续期记录列表
        await dispatch('getRenewalList', { page: 1, pageSize: 10 })
        return response.data
      }
      throw new Error(response.message || '续期失败')
    } catch (error) {
      console.error('续期失败:', error)
      throw error
    }
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
